class ResolvedViewportView {
    constructor(state) {
        this.state = Object.freeze(state);
    }
    toICamera() {
        this.cachedICamera ||= this.buildICamera();
        return this.cachedICamera;
    }
}
export default ResolvedViewportView;
